import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputCheckBox from '../../commons/form/InputCheckBox'
import DocumentTypeUseModalPage from '../../../containers/masters/DocumentTypeUse/DocumentTypeUseModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class DocumentTypeUseMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        entityTypeId: null,
        text: null,
        code: null,
        externalCode: null,
        canBePrinted: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchDocumentTypeCombo()
    this.props.actions.fetchDocumentTypeUseList()
    this.props.actions.fetchPermissionCombo()
    this.props.actions.fetchDocumentTypeUseCombo()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchDocumentTypeUseList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchDocumentTypeUseList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleTextChange (text) {
    if (this.state.filter.text !== text) {
      this.setState({ filter: { ...this.state.filter, text } })
    }
  }

  handleShowOnlyPrintableChange (canBePrinted) {
    canBePrinted = canBePrinted ? true : null
    if (this.state.filter.canBePrinted !== canBePrinted) {
      this.setState({ filter: { ...this.state.filter, canBePrinted } })
    }
  }

  handleExternalCodeChange (externalCode) {
    if (this.state.filter.externalCode !== externalCode) {
      this.setState({ filter: { ...this.state.filter, externalCode } })
    }
  }

  handleCodeChange (code) {
    if (this.state.filter.code !== code) {
      this.setState({ filter: { ...this.state.filter, code } })
    }
  }

  handleEntityChange (entityTypeId) {
    if (this.state.filter.entityTypeId !== entityTypeId) {
      this.setState({ filter: { ...this.state.filter, entityTypeId } })
    }
  }

  search () {
    this.props.actions.fetchDocumentTypeUseList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        entityTypeId: null,
        text: null,
        code: null,
        externalCode: null,
        canBePrinted: null
      }
    }, () => { this.search() })
  }

  render () {
    const {
      t, documentTypeUseList, pagesCount, documentTypeUsesCount, filter,
      combos: { documentType },
      filter: { page },
      actions: { openDocumentTypeUseModal, fetchDocumentTypeUseList, deleteDocumentTypeUse }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'documentTypeUseMasterPage' })
    const tKey = 'MASTERS.DOCUMENT_TYPE_USE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.code || this.state.filter.externalCode || this.state.filter.entityTypeId || this.state.filter.text || this.state.filter.canBePrinted)
    return (
      <div id='documentTypeUseMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openDocumentTypeUseModal()}>
              <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.entityTypeId"
                controlLabel={t(`${tKey}DOCUMENT_TYPE`)}
                placeholder={t(`${tKey}DOCUMENT_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={documentType}
                onInputChange={(value) => this.handleEntityChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                valueKey="code"
                labelKey="value"
                maxLength={50}
                onInputChange={(value) => this.handleCodeChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.externalCode"
                controlLabel={t(`${tKey}EXTERNAL_CODE`)}
                placeholder={t(`${tKey}EXTERNAL_CODE`)}
                valueKey="externalCode"
                labelKey="value"
                maxLength={50}
                onInputChange={(value) => this.handleExternalCodeChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.text"
                controlLabel={t(`${tKey}TEXT`)}
                placeholder={t(`${tKey}TEXT`)}
                valueKey="text"
                labelKey="value"
                maxLength={50}
                onInputChange={(value) => this.handleTextChange(value)}
              />
              <Field
                component={InputCheckBox}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.canBePrinted"
                placeholder={t(`${tKey}SHOW_ONLY_PRINTABLE`)}
                valueKey="code"
                labelKey="value"
                onInputChange={(value) => this.handleShowOnlyPrintableChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.search()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="iDocIcon-search"/>
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(documentTypeUseList !== null) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('documentTypeUseId') }}>
                        {t(`${tKey}ID`)}
                        <i className={this.getSortIcon('documentTypeUseId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('documentTypeId') }}>
                        {t(`${tKey}DOCUMENT_TYPE`)}
                        <i className={this.getSortIcon('documentTypeId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('code') }}>
                        {t(`${tKey}CODE`)}
                        <i className={this.getSortIcon('code')} />
                      </th>
                      <th onClick={() => { this.changeOrder('externalCode') }}>
                        {t(`${tKey}EXTERNAL_CODE`)}
                        <i className={this.getSortIcon('externalCode')} />
                      </th>
                      <th onClick={() => { this.changeOrder('localeName') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('localeName')} />
                      </th>
                      <th onClick={() => { this.changeOrder('localeDescription') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('localeDescription')} />
                      </th>
                      <th className='actions' onClick={() => { this.changeOrder('canBePrinted') }}>
                        {t(`${tKey}PRINTABLE`)}
                        <i className={this.getSortIcon('canBePrinted')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentTypeUseList && documentTypeUseList.map((documentTypeUse, idx) => {
                      return (
                        <tr key={idx} className={documentTypeUse.isDeleted ? 'is-deleted' : ''}>
                          <td>{documentTypeUse.documentTypeUseId}</td>
                          <td>{documentType && documentType.find(x => x.id === documentTypeUse.documentTypeId) && documentType.find(x => x.id === documentTypeUse.documentTypeId).value}</td>
                          <td>{documentTypeUse.code}</td>
                          <td>{documentTypeUse.externalCode}</td>
                          <td>{documentTypeUse.documentTypeUseLocales && documentTypeUse.documentTypeUseLocales.length > 0 ? documentTypeUse.documentTypeUseLocales.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected).name : ''}</td>
                          <td>{documentTypeUse.documentTypeUseLocales && documentTypeUse.documentTypeUseLocales.length > 0 ? documentTypeUse.documentTypeUseLocales.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected).description : ''}</td>
                          <td className='actions doneOk'>{documentTypeUse.canBePrinted && (<i className='iDocIcon-done-ok'></i>) }</td>
                          <td className='actions'>
                            {!documentTypeUse.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openDocumentTypeUseModal(documentTypeUse)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteDocumentTypeUse(documentTypeUse.documentTypeUseId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })
                    }
                  </tbody>
                </Table>
              }
              {(documentTypeUseList === null || documentTypeUseList === undefined || documentTypeUseList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={documentTypeUsesCount}
                    onSelectAction={(value) => fetchDocumentTypeUseList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <DocumentTypeUseModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDocumentType'
})(DocumentTypeUseMaster)
